import React from 'react';
import { UomMap } from '@zonofi/common/constants/uom';
import { CustomRadio } from '../../../components';
import './select-uom-drawer-content.scss';
import { UOM } from '@zonofi/zono-money-store';
import { TouchableOpacity } from '../../../common';

export const SelectUOMDrawerContent: React.FC<{
  onUomChange: (uom: UOM) => void;
  uomList: UOM[];
  selectedUOM?: UOM | undefined;
  lineQty: number;
}> = ({ onUomChange, uomList, selectedUOM, lineQty }) => {
  const baseUOM = uomList.find((uom) => uom.type === 'base');
  return (
    <div className="select-uom-drawer-content-container">
      <div className="select-uom-drawer-content">
        {uomList?.map((uomItem, index) => {
          return (
            <TouchableOpacity
              key={`${uomItem.uom}-${index}`}
              className="select-uom-drawer-content-row"
              onPress={() => onUomChange(uomItem)}
            >
              <CustomRadio checked={selectedUOM?.uom === uomItem.uom} />
              <span className="font-semibold">{`${lineQty} ${uomItem.uom} - ${
                uomItem.type === 'additional'
                  ? `(${lineQty * uomItem.packSize} ${baseUOM?.uom})`
                  : UomMap[uomItem.uom]
              }`}</span>
            </TouchableOpacity>
          );
        })}
      </div>
    </div>
  );
};
